module.exports = __webpack_public_path__ + "static/img/lipin.b26b4919.svg";